import { loadMessages } from "devextreme/localization";
import i18n from "../../../i18n";

export function applyDxMessageOverrides(): void {
  const messages = i18n.global.messages.value ?? i18n.global.messages;
  const ruMessages = (messages as Record<string, any>).ru;
  const close = ruMessages?.main?.close ?? "Закрыть";

  loadMessages({
    ru: {
      Cancel: close,
      "dxDataGrid-headerFilterCancel": close,
    },
  });
}
